import React from 'react';
import Fade from '@mui/material/Fade';
import {
  Container,
  LoadingIndicatorContainer,
  FadeDivWrapper,
} from './styles';
import ExchangeLoadingIndicator from './LoadingIndicator/component';
import ExchangeSearchParams from './SearchParams/component';
import ExchangeSearchResults from './SearchResults/component';
import ExchangeJobStatusReview from './JobStatusReview/component';

const Exchange: React.FC = () => (
  <Fade in>
    <FadeDivWrapper className="ExchangeFadeDiv">
      <LoadingIndicatorContainer>
        <ExchangeLoadingIndicator />
      </LoadingIndicatorContainer>
      <Container>
        <ExchangeSearchParams />
        <ExchangeSearchResults />
      </Container>
    </FadeDivWrapper>
  </Fade>
);

export default Exchange;
